import { Routes } from '@angular/router';
import { APP_ROUTES } from './util/constants';

export const routes: Routes = [
  {
    path: APP_ROUTES.AUTH,
    children: [
      {
        path: '',
        loadChildren: () =>
          import("./pages/auth/auth.module").then(m => m.AuthModule),
      }
    ]

  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: "full",
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/home/home.module').then(m => m.HomeModule)
      }
    ]
  }
];
